export enum VintageScoreUploadStatusEnum {
  UNKNOWN = "unknown",
  PENDING = "pending",
  PROCESSED = "processed",
}
